export default "__VITE_ASSET__fc792d2f__"